import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";

const Label = ({ children, htmlFor, errorText, required }) => {
  const classes = useStyles();
  const isError = !!errorText;

  return (
    <label className={`${classes.label} ${isError ? classes.error : ""}`} htmlFor={htmlFor}>
      {isError ? errorText : children}
      {required && <span className={classes.required}> *</span>}
    </label>
  );
};

Label.propTypes = {
  children: PropTypes.node.isRequired,
  htmlFor: PropTypes.string,
  errorText: PropTypes.string,
  required: PropTypes.bool,
};

Label.defaultProps = {
  htmlFor: null,
  errorText: null,
  required: false,
};

const useStyles = makeStyles({
  label: {
    display: "inline-block",
    fontSize: "14px",
    fontFamily: "Lato, sans-serif",
    fontWeight: "normal",
    color: "#0C0E29",
    opacity: 0.8,
    marginBottom: "4px",
  },
  error: {
    color: "#D84949 !important",
  },
  required: {
    marginLeft: "4px",
  },
});

export default Label;
